<template>
  <div id="app">
    <div class="top-view" v-if="blackList.indexOf($route.path)===-1">
      <div class="up-wrap" :style="{backgroundColor:isHome?'':'#fff'}">
        <div class="up-box">
          <div class="left"><img src="/static/home/images/logo.png" alt=""></div>
          <div class="right">
            <span class="username" :style="{color:isHome?'#fff':'#333'}" v-if="username">{{ username }}</span>
            <span class="username login" :style="{color:isHome?'#fff':'#333'}" v-else
                  @click="$router.push('/login')">登录</span>
            <img class="head" :src="head?head:'/static/home/images/head.png'" alt="">
            <div class="unfold-panel" v-show="getLogin()">
              <div class="item" @click="editNickname">修改昵称</div>
              <div class="item">
                <input type="file" @change="editImg">
                修改头像
              </div>
              <div class="item" @click="buyPackage">购买套餐</div>
              <div class="item" @click="outLogin">退出</div>
            </div>
          </div>
        </div>
      </div>
      <div class="breadcrumb-wrap" v-if="!isHome">
        <div class="breadcrumb">
          <span class="label">当前位置:</span>
          <div class="breadcrumb-box">
            <span class="breadcrumb-item"
                  @click="index<breadcrumb.length-1?navigator(item):''"
                  v-for="(item,index) in breadcrumb">
              <span :class="['text',index<breadcrumb.length-1?'is-link':'']">{{ item.title }}</span>
              <i class="el-icon-arrow-right arrow-right" v-show="index<breadcrumb.length-1"></i>
            </span>
          </div>
          <!--<el-breadcrumb separator-class="el-icon-arrow-right">-->
            <!--<el-breadcrumb-item v-for="(item,index) in breadcrumb" :key="index"-->
                                <!--style="line-height: 18px;font-size: 18px;"-->
                                <!--@click="saveTitle(title)"-->
                                <!--:to="{ path: item.path,query:item.query?item.query:{} }">-->
              <!--&lt;!&ndash;<svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon" class="color-main" style="width: 18px;height: 18px;"></svg-icon>&ndash;&gt;-->
              <!--{{ item.title }}-->
            <!--</el-breadcrumb-item>-->
          <!--</el-breadcrumb>-->
        </div>
      </div>
    </div>
    <router-view/>
    <el-dialog  title="电脑套餐"
                :visible.sync="buyPackageShow"
                :before-close="loginClose"
                width="546px">
      <div class="buy-wrap">
        <div class="buy-box">
          <div v-for="(item,index) in packageList"
               @click="selPackage=item.id"
               :class="['item',selPackage==item.id?'select':'']">
            <div class="left">
              <div class="name">{{item.name}}</div>
              <div class="time">生效天数：{{item.day}}</div>
            </div>
            <div class="price">¥ {{formatPrice(item.price)}}</div>
          </div>
        </div>
        <div class="btn-box">
          <div class="btn" @click="confirmBuy">微信支付</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="请微信扫码支付"
               :visible.sync="payCodeShow"
               @close="closePayCode"
               width="546px">
      <div class="pay-code-wrap" id="pay-code-box">
        <!--<img :src="payCode" alt="">-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex"
import {getToken} from "./utils/auth";
import {userSave} from "./api/login";
import {packageCheck,packageConfirm,packagePay,orderStatus} from "./api/package";
import {formatPrice} from "./utils/public";
import QRCode from 'qrcodejs2'

export default {
  name: 'App',
  data() {
    return {
      payCode:"",
      payCodeShow:false,
      selPackage:"",
      blackList: ["/login", "/register", "/changePsd"],
      isHome: true,
      formatPrice,
      timer:null,
    }
  },
  created() {
    if(getToken()){
      this.packageCheck()
    }
  },
  methods: {
    navigator(item){
      this.setPageTitle(item.title);
      this.$router.push({ path: item.path,query:item.query?item.query:{} })
    },
    closePayCode(){
      clearInterval(this.timer);
    },
    confirmBuy(){
      if(!this.selPackage){
        this.$message({
          message:"请选择套餐",
          type:"error",
        });
        return
      }
      let that=this;
      packageConfirm({package_id:this.selPackage}).then(res=>{
        packagePay({no:res.data}).then(async payRes=>{
          this.payCodeShow=true;
          this.$nextTick(()=>{
            let qrcode = new QRCode('pay-code-box', {
              text: payRes.data.url, // 需要转换为二维码的内容
              width: 200,
              height: 200,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
            });
            this.timer=setInterval(()=>{
              orderStatus({no:res.data}).then(res=>{
                if(res.data==1){
                  that.$alert('支付成功', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                      location.href="/"
                    }
                  });
                  that.buyPackageShow(false)
                  that.payCodeShow=false;
                  clearInterval(that.timer);
                }
              }).catch(err=>{})
            },5000);
          })
        })
      })
    },
    packageCheck(){
      packageCheck().then(res=>{
        this.setPackageBuy(res.data==1)
      })
    },
    loginClose(){
      this.setPackageShow(false)
    },
    buyPackage(){
      if(this.packageBuy){
        this.$alert('已购买套餐', '提示', {
          confirmButtonText: '确定',
          callback: action => {}
        });
        return
      }
      this.GetPackAge()
    },
    getLogin() {
      return getToken();
    },
    outLogin() {
      this.LogOut().then(res => {
        this.$router.push({
          path: '/login',
        })
      }).catch(err => {

      })
    },
    editNickname() {
      this.$prompt('请输入昵称', '提示', {
        inputValue: this.username,
        confirmButtonText: '修改',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputValidator: (value) => {
          if (!value) {
            return false
          }
        },
        inputErrorMessage: '请输入昵称'
      }).then(({value}) => {
        userSave({nickname: value}).then(res => {
          this.GetInfo().then(res => {
          }).catch(err => {

          })
          this.$message({
            type: 'success',
            message: '修改昵称成功!'
          });
        })
      });
    },
    editImg(e) {
      let files = e.target.files;
      let imgTypes = [".jpg", ".png", ".jpeg"];
      let path = files[0].name;
      let size = files[0].size;
      let type = path.substring(path.lastIndexOf(".")).toLowerCase();
      if (imgTypes.indexOf(type) === -1) {
        this.$message({type: 'error', message: '图片格式错误!'});
        return
      }
      if (size > 4 * 1024 * 1024) {
        this.$message({type: 'error', message: '图片需小于4M!'});
        return
      }
      let formData = new FormData;
      formData.append('img', files[0])
      userSave(formData).then(res => {
        this.GetInfo().then(res => {
        }).catch(err => {

        })
      }).catch(err => {
      });
      e.target.value = "";
    },
    ...mapActions(['LogOut', 'GetInfo',"GetPackAge",]),
    ...mapMutations({setBreadcrumb: "SET_BREADCRUMB",setPackageShow:"SET_BUY_PACKAGE_SHOW",setPackageBuy:"SET_PACKAGE_BUY",setPageTitle: "SET_PAGE_TITLE"}),
  },
  watch: {
    "$route": function (newVal, oldVal) {
      if(newVal.meta.hidden){
        return
      }
      this.isHome = newVal.path == "/home";
      let breadcrumb = JSON.parse(JSON.stringify(this.breadcrumb));
      let like = false;
      for (let i = 0; i < breadcrumb.length; i++) {
        if (newVal.path == breadcrumb[i].path) {
          breadcrumb.splice(i + 1, breadcrumb.length - i - 1);
          like = true;
          break
        }
      }
      if (!like) {
        let obj = {
          path: newVal.path,
          title: newVal.meta.customTitle?newVal.meta.title:this.pageTitle,
          query: newVal.query,
        };
        breadcrumb.push(obj);
      }

      this.setBreadcrumb(breadcrumb);
      sessionStorage.setItem('breadcrumb', JSON.stringify(breadcrumb));
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapGetters(["username", "head", "breadcrumb", "pageTitle","packageList","buyPackageShow","packageBuy"])
  }
}
</script>

<style scoped lang="less">
#app {
  width: 100%;
  height: 100%;

  .pay-code-wrap{
    display: flex;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 40px;
    img{
      width: 200px;
      height: 200px;
    }
  }
  /deep/ .el-dialog__body{
    padding: 0 20px;
  }
  .buy-wrap{
    .buy-box{
      min-height: 324px;
      border-top: 1px solid #EBEDF5;
      border-bottom: 1px solid #EBEDF5;
      margin-bottom: 10px;
      .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px 8px;
        border-radius: 8px;
        border: 1px solid #D7D7D7;
        background-color: #fff;
        color:#333;
        margin-top: 10px;
        .left{
          .name{
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            margin-bottom: 5px;
          }
          .time{
            font-size: 12px;
            line-height: 18px;
          }
        }
        .price{
          font-size: 16px;
          line-height: 22px;
        }
      }
      .item.select{
        border: 1px solid #2C79E1;
        background-color: #2C79E1;
        color:#fff;
      }
    }
    .btn-box {
      padding-bottom: 10px;
      .btn{
        font-size: 14px;
        color:#fff;
        background-color: #2C79E1;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .top-view {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    z-index: 1;

    .up-wrap {
      width: 100%;
      display: flex;
      justify-content: center;

      .up-box {
        height: 70px;
        width: 1200px;
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;

        .left {
          height: 40px;

          img {
            width: auto;
            height: 100%;
          }
        }

        .right {
          font-size: 24px;
          line-height: 40px;
          position: relative;

          .username {
            display: inline-block;
            vertical-align: middle;
          }

          .login {
            cursor: pointer;
          }

          .head {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-left: 10px;
            vertical-align: middle;
          }

          &:hover .unfold-panel {
            display: block;
          }

          .unfold-panel {
            padding-top: 10px;
            display: none;
            position: absolute;
            top: 40px;
            right: 0;
            width: 100px;
            box-sizing: border-box;
            //box-shadow: 0 2px 4px 1px rgba(0, 0, 0, .3);
            border-radius: 2px 0 0 2px;

            .item {
              height: 40px;
              line-height: 40px;
              font-size: 20px;
              border-bottom: 1px solid #d8d8d8;
              padding-left: 10px;
              box-sizing: border-box;
              color: #333;
              background-color: white;
              position: relative;

              input[type="file"] {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                opacity: 0;
                z-index: 1;
              }
            }

            .item:hover {
              cursor: pointer;
              background-color: #d3d3d3;
            }
          }
        }
      }
    }

    .breadcrumb-wrap {
      display: flex;
      justify-content: center;
      background-color: @theme-color;
      .breadcrumb {
        width: 1200px;
        padding-top: 26px;
        padding-bottom: 10px;
        height: 58px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        text-indent: 5px;

        .label {
          font-size: 18px;
          margin-right: 10px;
        }
        .breadcrumb-box{
          font-size: 18px;
          line-height: 1;
          &:before {
            display: table;
            content: "";
          }
          .breadcrumb-item{
            float: left;
            .text{
              font-weight: 400;
              color: #606266;
              cursor: text;
            }
            .is-link{
              font-weight: 700;
              -webkit-transition: color .2s cubic-bezier(.645,.045,.355,1);
              transition: color .2s cubic-bezier(.645,.045,.355,1);
              color: #303133;
              &:hover{
                color: #4695ff;
                cursor: pointer;
              }
            }
            .arrow-right{
              margin: 0 6px;
              font-weight: 400;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue